import { TextInput } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { CollapsibleCard, InputPhoneNumber, InputUrl } from '@flecto/ui'

import { FormImages } from '../FormStoreSettings/FormImages'
import { FormSection } from '../FormStoreSettings/FormSection'
import { useFormContext } from '../FormStoreSettings/FormStoreSettings'

export function CardStoreContactInfo() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_store' })

  const form = useFormContext()

  return (
    <FormSection>
      <CollapsibleCard opened>
        <CollapsibleCard.Title>
          {t('section_contact.title')}
        </CollapsibleCard.Title>
        <CollapsibleCard.Description>
          {t('section_contact.description')}
        </CollapsibleCard.Description>
        <CollapsibleCard.Content>
          <TextInput
            mt='sm'
            key={form.key('email')}
            label={t('section_contact.email')}
            {...form.getInputProps('email')}
          />
          <InputPhoneNumber
            key={form.key('phone_number')}
            mt='lg'
            label={t('section_contact.phone_number')}
            valueDialCode={form.values.phone_number_country_code as string}
            onChangeDialCode={(value) =>
              form.setFieldValue(
                'phone_number_country_code',
                String(value ?? '')
              )
            }
            {...form.getInputProps('phone_number')}
          />
          <InputUrl
            key={form.key('social_instagral_url')}
            mt='lg'
            label='Instagram URL'
            placeholder='instagram.com/@yourstore'
            {...form.getInputProps('social_instagram_url')}
          />
          <InputUrl
            key={form.key('social_facebook_url')}
            mt='lg'
            label='Facebook URL'
            placeholder='facebook.com/yourstore'
            {...form.getInputProps('social_facebook_url')}
          />
          <InputUrl
            key={form.key('social_linkedin_url')}
            mt='lg'
            label='Linkedin URL'
            placeholder='linkedin.com/in/yourstore'
            {...form.getInputProps('social_linkedin_url')}
          />
          <InputUrl
            key={form.key('social_twitter_url')}
            mt='lg'
            label='Twitter (X) URL'
            placeholder='x.com/yourstore'
            {...form.getInputProps('social_twitter_url')}
          />
          <InputUrl
            key={form.key('social_google_url')}
            mt='lg'
            label='Google URL'
            {...form.getInputProps('social_google_url')}
          />
        </CollapsibleCard.Content>
      </CollapsibleCard>
      <FormImages images={[require('./image.jpeg')]} />
    </FormSection>
  )
}
